import { render, staticRenderFns } from "./SendMailExtended.vue?vue&type=template&id=0d7ebc6b&scoped=true&"
import script from "./SendMailExtended.vue?vue&type=script&lang=js&"
export * from "./SendMailExtended.vue?vue&type=script&lang=js&"
import style0 from "./SendMailExtended.vue?vue&type=style&index=0&id=0d7ebc6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7ebc6b",
  null
  
)

export default component.exports